(function () {
  "use strict";

  var APP_ID = "bqa-riverflow-mobile";
  var DEFAULT_REPORT_URL = "https://bluequillangler.com/pages/river-page-cheesman-canyon";

/*
  River-specific fishing report links:
  Replace the placeholder URLs below with each actual BQA fishing report page.
*/
var REPORT_URLS = {
  "07087050": DEFAULT_REPORT_URL,
  "07093700": DEFAULT_REPORT_URL,
  "06710350": DEFAULT_REPORT_URL,
  "06710500": DEFAULT_REPORT_URL,
  "09050700": DEFAULT_REPORT_URL,
  "09057500": DEFAULT_REPORT_URL,
  "06716500": DEFAULT_REPORT_URL,
  "06719505": DEFAULT_REPORT_URL,
  "09058000": DEFAULT_REPORT_URL,
  "09098750": DEFAULT_REPORT_URL,
  "06707500": DEFAULT_REPORT_URL,
  "06701500": "https://bluequillangler.com/pages/river-page-cheesman-canyon",
  "06701900": DEFAULT_REPORT_URL,
  "09037500": DEFAULT_REPORT_URL
};

  var state = {
    filter: "all",
    search: "",
    rows: [],
    favorites: [],
    loadedAt: null,
    historicalCache: {},
    weatherCache: {}
  };

  var GAUGES = [
    { name: "Arkansas - Near Granite", group: "Arkansas River", site: "07087050", idealLow: 150, idealHigh: 600, reportUrl: DEFAULT_REPORT_URL },
    { name: "Arkansas - At Salida", group: "Arkansas River", site: "07093700", dwr: "ARKSALCO", idealLow: 300, idealHigh: 1200, reportUrl: DEFAULT_REPORT_URL },
       { name: "Bear Creek - Morrison", group: "Bear Creek", site: "06710500",dwr: "BCRMORCO", idealLow: 20, idealHigh: 150, reportUrl: DEFAULT_REPORT_URL },
    { name: "Blue River - Below Dillon", group: "Blue River", site: "09050700", idealLow: 80, idealHigh: 350, reportUrl: DEFAULT_REPORT_URL },
    { name: "Blue River - Below Green Mountain Res", group: "Blue River", site: "09057500", idealLow: 250, idealHigh: 900, reportUrl: DEFAULT_REPORT_URL },
    { name: "Clear Creek - Near Lawson", group: "Clear Creek", site: "06716500", idealLow: 50, idealHigh: 350, reportUrl: DEFAULT_REPORT_URL },
    { name: "Clear Creek - Golden", group: "Clear Creek", site: "06719505", idealLow: 50, idealHigh: 500, reportUrl: DEFAULT_REPORT_URL },
    { name: "Colorado - Near Kremmling", group: "Colorado River", site: "09058000", idealLow: 500, idealHigh: 2000, reportUrl: DEFAULT_REPORT_URL },
    { name: "Colorado - Near Parshall", group: "Colorado River", site: "09098750", idealLow: 400, idealHigh: 1800, reportUrl: DEFAULT_REPORT_URL },
   
    { name: "South Platte - Charlie Meyers / Dream Stream", group: "South Platte River", site: "06707500", dwr: "PLAHARCO", idealLow: 80, idealHigh: 250, reportUrl: DEFAULT_REPORT_URL },
    { name: "South Platte - Cheesman Canyon", group: "South Platte River", site: "06701500", dwr: "PLACHECO", idealLow: 100, idealHigh: 350, reportUrl: DEFAULT_REPORT_URL },
    { name: "South Platte - Deckers", group: "South Platte River", site: "06701900", idealLow: 100, idealHigh: 450, reportUrl: DEFAULT_REPORT_URL },
    { name: "Williams Fork - Near Parshall", group: "Williams Fork", site: "09037500", idealLow: 80, idealHigh: 350, reportUrl: DEFAULT_REPORT_URL }
  ];

  var WEATHER_COORDS = {
    "07087050": { lat: 39.045, lon: -106.265 },
    "07093700": { lat: 38.535, lon: -105.998 },
    "06710350": { lat: 39.633, lon: -105.317 },
    "06710500": { lat: 39.654, lon: -105.191 },
    "09050700": { lat: 39.628, lon: -106.066 },
    "09057500": { lat: 39.879, lon: -106.332 },
    "06716500": { lat: 39.765, lon: -105.617 },
    "06719505": { lat: 39.755, lon: -105.221 },
    "09058000": { lat: 40.058, lon: -106.389 },
    "09098750": { lat: 40.059, lon: -106.176 },
    "06707500": { lat: 38.999, lon: -105.897 },
    "06701500": { lat: 39.215, lon: -105.278 },
    "06701900": { lat: 39.255, lon: -105.226 },
    "09037500": { lat: 40.036, lon: -106.176 }
  };

  function startRiverFlowApp() {
    waitForPageFlyElements(0);
  }

  function waitForPageFlyElements(attempt) {
    var app = document.getElementById(APP_ID);
    var listEl = document.getElementById("bqa-rf-list");
    var statusEl = document.getElementById("bqa-rf-status");

    if (app && listEl && statusEl) {
      initRiverFlow();
      return;
    }

    if (attempt < 60) {
      setTimeout(function () {
        waitForPageFlyElements(attempt + 1);
      }, 250);
    }
  }

  function initRiverFlow() {
    var app = document.getElementById(APP_ID);

    if (!app) return;
    if (app.getAttribute("data-riverflow-initialized") === "true") return;

    app.setAttribute("data-riverflow-initialized", "true");
    state.favorites = loadFavorites();

    var refreshBtn = document.getElementById("bqa-rf-refresh");
    var searchEl = document.getElementById("bqa-rf-search");

    if (refreshBtn) refreshBtn.addEventListener("click", loadData);

    if (searchEl) {
      searchEl.addEventListener("input", function () {
        state.search = searchEl.value || "";
        render();
      });
    }

    app.querySelectorAll("[data-bqa-filter]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        state.filter = btn.getAttribute("data-bqa-filter") || "all";
        render();
      });
    });

    loadData();
    setInterval(updateRelativeTime, 60000);
  }

  function loadData() {
    var listEl = document.getElementById("bqa-rf-list");
    var statusEl = document.getElementById("bqa-rf-status");

    if (statusEl) statusEl.innerHTML = "Contacting USGS river data service...";
    if (listEl) listEl.innerHTML = "<div class='bqa-rf-empty'><strong>Fetching live river data...</strong></div>";

    var sites = GAUGES.map(function (gauge) {
      return gauge.site;
    }).join(",");

    var url =
      "https://waterservices.usgs.gov/nwis/iv/?format=json&sites=" +
      encodeURIComponent(sites) +
      "&parameterCd=00060,00010&siteStatus=all&period=P7D";

    fetch(url, { cache: "no-store" })
      .then(function (response) {
        if (!response.ok) throw new Error("USGS API Error: " + response.status);
        return response.json();
      })
      .then(function (data) {
        state.rows = buildRows(data);
        state.loadedAt = new Date();
        updateHeaderTime();
        fillMissingFlowsFromDwr();
      })
      .catch(function (error) {
        if (statusEl) statusEl.innerHTML = "USGS river data failed to load: " + escapeHtml(String(error.message || error));
        if (listEl) listEl.innerHTML = "<div class='bqa-rf-empty'><strong>Error loading river data.</strong><br>" + escapeHtml(String(error.message || error)) + "</div>";
      });
  }

  function buildRows(data) {
    var siteMap = {};

    GAUGES.forEach(function (gauge) {
      siteMap[gauge.site] = {
        gauge: gauge,
        flow: null,
        temp: null,
        flowPoints: [],
        latestTime: null,
        source: "USGS"
      };
    });

    var series = data && data.value && data.value.timeSeries ? data.value.timeSeries : [];

    series.forEach(function (item) {
      var site = item.sourceInfo && item.sourceInfo.siteCode && item.sourceInfo.siteCode[0]
        ? item.sourceInfo.siteCode[0].value
        : null;

      var variable = item.variable && item.variable.variableCode && item.variable.variableCode[0]
        ? item.variable.variableCode[0].value
        : null;

      var values = item.values && item.values[0] && item.values[0].value
        ? item.values[0].value
        : [];

      if (!site || !siteMap[site] || !values.length) return;

      if (variable === "00060") {
        var flowPoints = values.map(function (reading) {
          return {
            value: Number(reading.value),
            time: reading.dateTime
          };
        }).filter(function (point) {
          return point.time && !isNaN(point.value);
        });

        if (flowPoints.length) {
          var latestFlow = flowPoints[flowPoints.length - 1];
          siteMap[site].flow = Math.round(latestFlow.value);
          siteMap[site].latestTime = latestFlow.time;
          siteMap[site].flowPoints = flowPoints;
          siteMap[site].source = "USGS";
        }
      }

      if (variable === "00010") {
        var latestTemp = values[values.length - 1];
        var tempC = Number(latestTemp.value);
        if (!isNaN(tempC)) siteMap[site].temp = ((tempC * 9) / 5 + 32).toFixed(1);
      }
    });

    return GAUGES.map(function (gauge) {
      return siteMap[gauge.site];
    });
  }

  function fillMissingFlowsFromDwr() {
    var dwrRows = state.rows.filter(function (row) {
      return row.flow === null && row.gauge.dwr;
    });

    if (!dwrRows.length) {
      render();
      return;
    }

    Promise.all(
      dwrRows.map(function (row) {
        return fetchDwrFlow(row.gauge.dwr).then(function (dwrData) {
          row.flow = dwrData.flow;
          row.latestTime = dwrData.time;
          row.flowPoints = dwrData.flowPoints;
          row.source = "Colorado DWR";
        }).catch(function () {});
      })
    ).then(function () {
      render();
    });
  }

  function fetchDwrFlow(dwrCode) {
    var today = new Date();
    var start = new Date();
    var end = new Date();

    start.setDate(today.getDate() - 7);
    end.setDate(today.getDate() + 1);

    function ymd(date) {
      return date.toISOString().slice(0, 10);
    }

    var url =
      "https://dwr.state.co.us/Rest/GET/api/v2/telemetrystations/telemetrytimeserieshour/?" +
      "format=json" +
      "&abbrev=" + encodeURIComponent(dwrCode) +
      "&parameter=DISCHRG" +
      "&startDate=" + ymd(start) +
      "&endDate=" + ymd(end) +
      "&pageSize=5000";

    return fetch(url, { cache: "no-store" })
      .then(function (response) {
        if (!response.ok) throw new Error("DWR API Error: " + response.status);
        return response.json();
      })
      .then(function (payload) {
        var rows =
          payload.ResultList ||
          payload.resultList ||
          payload.results ||
          payload;

        if (!rows || !rows.length) throw new Error("No DWR data");

        var flowPoints = rows.map(function (r) {
          var time =
            r.measDate ||
            r.measdate ||
            r.measDateTime ||
            r.measdatetime ||
            r.date_time ||
            r.dateTime;

          var value = Number(
            r.measValue ||
            r.measvalue ||
            r.amount ||
            r.value
          );

          return {
            time: time,
            value: value
          };
        }).filter(function (point) {
          return point.time && !isNaN(point.value);
        });

        flowPoints.sort(function (a, b) {
          return new Date(a.time) - new Date(b.time);
        });

        if (!flowPoints.length) throw new Error("No usable DWR flow points");

        var latestPoint = flowPoints[flowPoints.length - 1];

        return {
          flow: Math.round(latestPoint.value),
          time: latestPoint.time,
          flowPoints: flowPoints
        };
      });
  }

  function render() {
    var app = document.getElementById(APP_ID);
    var listEl = document.getElementById("bqa-rf-list");
    var statusEl = document.getElementById("bqa-rf-status");

    if (!app || !listEl) return;

    app.querySelectorAll("[data-bqa-filter]").forEach(function (btn) {
      btn.classList.toggle("active", btn.getAttribute("data-bqa-filter") === state.filter);
    });

    var rows = filteredRows();

    if (statusEl) {
      statusEl.innerHTML =
        "Live USGS and Colorado DWR river conditions • " +
        rows.length +
        " of " +
        state.rows.length +
        " rivers • " +
        relativeLoadedText();
    }

    if (!rows.length) {
      listEl.innerHTML = "<div class='bqa-rf-empty'>No rivers match this view.</div>";
      return;
    }

    var html = "";
    var previousGroup = "";

    rows.forEach(function (row) {
      if (state.filter !== "best" && row.gauge.group !== previousGroup) {
        previousGroup = row.gauge.group;
        html += "<div class='bqa-rf-group-title'>" + escapeHtml(previousGroup || "Other Waters") + "</div>";
      }
      html += cardHtml(row);
    });

    listEl.innerHTML = html;
    attachCardHandlers(listEl);
  }

  function attachCardHandlers(listEl) {
    listEl.querySelectorAll("[data-expand-card]").forEach(function (card) {
      card.addEventListener("click", function (event) {
        var tag = event.target.tagName.toLowerCase();
        if (tag === "a" || tag === "button") return;

        card.classList.toggle("open");

        if (card.classList.contains("open")) {
          var site = card.getAttribute("data-site");
          var row = findRow(site);
          loadHistoricalAndRenderChart(row, card);
          loadWeatherAndRender(row, card);
        }
      });
    });

    listEl.querySelectorAll("[data-favorite]").forEach(function (button) {
      button.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        toggleFavorite(button.getAttribute("data-favorite"));
      });
    });
  }

  function filteredRows() {
    var query = state.search.trim().toLowerCase();
    var rows = state.rows.slice();

    if (query) {
      rows = rows.filter(function (row) {
        return row.gauge.name.toLowerCase().indexOf(query) !== -1 ||
          (row.gauge.group || "").toLowerCase().indexOf(query) !== -1;
      });
    }

    if (state.filter === "favorites") {
      rows = rows.filter(function (row) {
        return isFavorite(row.gauge.site);
      });
    }

    if (state.filter === "temps") {
      rows = rows.filter(function (row) {
        return Number(row.temp) >= 66;
      });
    }

    if (state.filter === "best") {
      rows = rows.slice().sort(function (a, b) {
        return conditionScore(b) - conditionScore(a);
      });
    }

    return rows;
  }

  function cardHtml(row) {
    var flowText = row.flow === null ? "-- cfs" : row.flow.toLocaleString() + " cfs";
    var tempText = row.temp ? row.temp + " deg" : "No temp";
    var trend = trendInfo(row);
    var rec = recommendation(row);
    var flies = flyRecommendation(row);
    var tempCls = tempClass(row.temp);
    var favoriteCls = isFavorite(row.gauge.site) ? " active" : "";
    var stationText = row.source === "Colorado DWR" ? row.gauge.dwr : row.gauge.site;
    var reportUrl = reportUrlFor(row);

    return "<div class='bqa-rf-card' data-expand-card data-site='" + escapeHtml(row.gauge.site) + "'>" +
      "<button class='bqa-rf-fav" + favoriteCls + "' type='button' data-favorite='" + escapeHtml(row.gauge.site) + "' aria-label='Favorite this river'>★</button>" +
      "<div class='bqa-rf-river'>" + escapeHtml(row.gauge.name) + "</div>" +
      "<div class='bqa-rf-mini-spark'>" + miniSparkline(row.flowPoints) + "</div>" +
      "<div class='bqa-rf-flow'>" + escapeHtml(flowText) + "</div>" +
      "<div class='bqa-rf-temp" + tempCls + "'>" + escapeHtml(tempText) + "</div>" +
     
      "<a class='bqa-rf-report-link' href='" + escapeHtml(reportUrl) + "'>Fishing Report</a>" +
      "<span class='bqa-rf-badge " + rec.className + "'>" + escapeHtml(rec.label) + "</span>" +
      "<div class='bqa-rf-details'>" +
        "<strong>Data Source:</strong> " + escapeHtml(row.source || "USGS") + "<br>" +
        "<strong>Station:</strong> " + escapeHtml(stationText || "") + "<br>" +
        "<strong>Current Flow:</strong> " + escapeHtml(flowText) + "<br>" +
        "<strong>Last Reading:</strong> " + escapeHtml(formatReadingTime(row.latestTime)) + "<br>" +
        "<strong>Ideal Range:</strong> " + row.gauge.idealLow.toLocaleString() + "-" + row.gauge.idealHigh.toLocaleString() + " cfs<br>" +
        "<strong>Water Temp:</strong> " + escapeHtml(row.temp ? row.temp + " F" : "No temperature sensor") + "<br>" +
        "<strong>Trend:</strong> " + escapeHtml(trend.text) +
        "<div class='bqa-rf-flies'>" +
          "<div class='bqa-rf-flies-title'>Fly Recommendations</div>" +
          "<div class='bqa-rf-flies-list'>" + escapeHtml(flies.flies) + "</div>" +
          "<div class='bqa-rf-flies-tip'>" + escapeHtml(flies.tip) + "</div>" +
        "</div>" +
        "<div class='bqa-rf-chart-status' data-chart-status>Tap to load 7-day flow chart...</div>" +
        "<div class='bqa-rf-chart' data-flow-chart></div>" +
        "<div class='bqa-rf-weather-status' data-weather-status>Tap to load 5-day weather outlook...</div>" +
        "<div class='bqa-rf-weather' data-weather-outlook></div>" +
      "</div>" +
    "</div>";
  }

  function reportUrlFor(row) {
    return REPORT_URLS[row.gauge.site] || row.gauge.reportUrl || DEFAULT_REPORT_URL;
  }

  function miniSparkline(points) {
    var clean = (points || []).filter(function (p) {
      return p && !isNaN(p.value);
    });

    if (clean.length < 2) return "";

    clean = clean.slice(-24);

    var values = clean.map(function (p) { return p.value; });
    var min = Math.min.apply(null, values);
    var max = Math.max.apply(null, values);
    var range = max - min || 1;
    var width = 72;
    var height = 26;
    var pad = 3;

    var d = clean.map(function (p, i) {
      var x = pad + (i / Math.max(clean.length - 1, 1)) * (width - pad * 2);
      var y = height - pad - ((p.value - min) / range) * (height - pad * 2);
      return (i === 0 ? "M" : "L") + x.toFixed(1) + " " + y.toFixed(1);
    }).join(" ");

    return "<svg viewBox='0 0 " + width + " " + height + "' preserveAspectRatio='none'><path d='" + d + "'></path></svg>";
  }

  function flyRecommendation(row) {
    var group = row.gauge.group || "";
    var temp = Number(row.temp);
    var flow = row.flow;
    var month = new Date().getMonth() + 1;
    var highWater = flow !== null && flow > row.gauge.idealHigh;
    var lowWater = flow !== null && flow < row.gauge.idealLow;
    var warm = !isNaN(temp) && temp >= 66;

    if (warm) {
      return {
        flies: "Tricos, PMDs, caddis dries, small ants, beetles",
        tip: "Watch water temps closely. Fish early, land trout quickly, and avoid stressing fish during warm afternoons."
      };
    }

    if (highWater) {
      return {
        flies: "San Juan Worms, Pats Rubber Legs, scuds, larger attractor nymphs, streamers",
        tip: "Focus on soft edges, inside seams, banks, and slower pockets where trout can escape heavy current."
      };
    }

    if (lowWater) {
      return {
        flies: "RS2s, Zebra Midges, small Baetis nymphs, Griffiths Gnats, Parachute Adams",
        tip: "Use lighter tippet, longer leaders, careful approaches, and smaller flies in clear or skinny water."
      };
    }

    if (group.indexOf("South Platte") !== -1) {
      return {
        flies: "RS2s, Mercury Midges, Top Secret Midges, Barrs Emergers, San Juan Worms",
        tip: "Start with small technical nymphs. Add a worm or egg pattern when flows bump or water has color."
      };
    }

    if (group.indexOf("Blue River") !== -1) {
      return {
        flies: "Mysis Shrimp, Zebra Midges, RS2s, small Baetis, eggs",
        tip: "Tailwater fish can be selective. Keep rigs small and clean unless flows are up."
      };
    }

    if (group.indexOf("Colorado") !== -1 || group.indexOf("Williams") !== -1) {
      return {
        flies: "Caddis larvae, pheasant tails, stoneflies, streamers, Chubby Chernobyls when warm",
        tip: "Cover water and look for banks, riffle edges, and soft seams. Streamers can be good with cloud cover."
      };
    }

    if (month >= 6 && month <= 9) {
      return {
        flies: "Elk Hair Caddis, PMDs, hoppers, ants, beetles, pheasant tails",
        tip: "Look for dry-dropper opportunities and faster oxygenated water during warmer parts of the season."
      };
    }

    return {
      flies: "Zebra Midges, RS2s, Pheasant Tails, Hares Ears, small streamers",
      tip: "Start with a small nymph rig and adjust depth before changing flies."
    };
  }

  function loadWeatherAndRender(row, card) {
    if (!row || !card) return;

    var weatherEl = card.querySelector("[data-weather-outlook]");
    var statusEl = card.querySelector("[data-weather-status]");

    if (!weatherEl || weatherEl.getAttribute("data-rendered") === "true") return;

    if (state.weatherCache[row.gauge.site]) {
      renderWeatherIntoCard(row, card, state.weatherCache[row.gauge.site]);
      return;
    }

    if (statusEl) statusEl.innerHTML = "Loading 5-day weather outlook...";

    fetchWeather(row.gauge.site)
      .then(function (weather) {
        state.weatherCache[row.gauge.site] = weather;
        renderWeatherIntoCard(row, card, weather);
      })
      .catch(function () {
        if (statusEl) statusEl.innerHTML = "Weather outlook unavailable.";
        weatherEl.innerHTML = "<div class='bqa-rf-weather-title'>Weather could not load</div>";
      });
  }

  function fetchWeather(site) {
    var coords = WEATHER_COORDS[site];
    if (!coords) return Promise.reject(new Error("No weather coordinates configured"));

    var url =
      "https://api.open-meteo.com/v1/forecast" +
      "?latitude=" + encodeURIComponent(coords.lat) +
      "&longitude=" + encodeURIComponent(coords.lon) +
      "&daily=weather_code,temperature_2m_max,temperature_2m_min,precipitation_probability_max,wind_speed_10m_max" +
      "&temperature_unit=fahrenheit" +
      "&wind_speed_unit=mph" +
      "&precipitation_unit=inch" +
      "&timezone=auto" +
      "&forecast_days=5";

    return fetch(url, { cache: "no-store" })
      .then(function (response) {
        if (!response.ok) throw new Error("Weather API error");
        return response.json();
      });
  }

  function renderWeatherIntoCard(row, card, weather) {
    var weatherEl = card.querySelector("[data-weather-outlook]");
    var statusEl = card.querySelector("[data-weather-status]");

    if (!weatherEl) return;

    weatherEl.innerHTML = makeWeatherOutlook(weather);
    weatherEl.setAttribute("data-rendered", "true");

    if (statusEl) statusEl.innerHTML = "5-day weather outlook for this river area.";
  }

  function makeWeatherOutlook(weather) {
    var daily = weather && weather.daily ? weather.daily : null;
    if (!daily || !daily.time || !daily.time.length) {
      return "<div class='bqa-rf-weather-title'>Weather outlook unavailable</div>";
    }

    var html = "<div class='bqa-rf-weather-title'>5-Day Weather Outlook</div>";
    html += "<div class='bqa-rf-weather-grid'>";

    for (var i = 0; i < daily.time.length; i++) {
      var date = daily.time[i];
      var high = daily.temperature_2m_max ? daily.temperature_2m_max[i] : null;
      var low = daily.temperature_2m_min ? daily.temperature_2m_min[i] : null;
      var precip = daily.precipitation_probability_max ? daily.precipitation_probability_max[i] : null;
      var wind = daily.wind_speed_10m_max ? daily.wind_speed_10m_max[i] : null;
      var code = daily.weather_code ? daily.weather_code[i] : null;

      html += "<div class='bqa-rf-weather-day'>" +
        "<div class='bqa-rf-weather-date'>" + escapeHtml(formatWeatherDate(date)) + "</div>" +
        "<div class='bqa-rf-weather-main'>" + escapeHtml(weatherIcon(code)) + " " + escapeHtml(formatTempRange(low, high)) + "</div>" +
        "<div class='bqa-rf-weather-sub'>" + escapeHtml(weatherLabel(code)) + "</div>" +
        "<div class='bqa-rf-weather-sub'>Rain: " + escapeHtml(precip === null || precip === undefined ? "--" : Math.round(precip) + "%") + "</div>" +
        "<div class='bqa-rf-weather-sub'>Wind: " + escapeHtml(wind === null || wind === undefined ? "--" : Math.round(wind) + " mph") + "</div>" +
      "</div>";
    }

    html += "</div>";
    return html;
  }

  function formatTempRange(low, high) {
    if (low === null || low === undefined || high === null || high === undefined) return "--";
    return Math.round(low) + "-" + Math.round(high) + " deg";
  }

  function formatWeatherDate(dateStr) {
    try {
      return new Date(dateStr + "T12:00:00").toLocaleDateString([], { weekday: "short", month: "short", day: "numeric" });
    } catch (e) {
      return dateStr;
    }
  }

  function weatherIcon(code) {
    code = Number(code);
    if (code === 0) return "Clear";
    if ([1, 2].indexOf(code) !== -1) return "Partly";
    if (code === 3) return "Cloudy";
    if ([45, 48].indexOf(code) !== -1) return "Fog";
    if ([51, 53, 55, 56, 57, 61, 63, 65, 66, 67, 80, 81, 82].indexOf(code) !== -1) return "Rain";
    if ([71, 73, 75, 77, 85, 86].indexOf(code) !== -1) return "Snow";
    if ([95, 96, 99].indexOf(code) !== -1) return "Storm";
    return "Forecast";
  }

  function weatherLabel(code) {
    code = Number(code);
    if (code === 0) return "Clear";
    if (code === 1) return "Mostly clear";
    if (code === 2) return "Partly cloudy";
    if (code === 3) return "Cloudy";
    if ([45, 48].indexOf(code) !== -1) return "Fog";
    if ([51, 53, 55, 56, 57].indexOf(code) !== -1) return "Drizzle";
    if ([61, 63, 65, 66, 67, 80, 81, 82].indexOf(code) !== -1) return "Rain";
    if ([71, 73, 75, 77, 85, 86].indexOf(code) !== -1) return "Snow";
    if ([95, 96, 99].indexOf(code) !== -1) return "Thunderstorms";
    return "Forecast";
  }

  function loadHistoricalAndRenderChart(row, card) {
    if (!row || !card) return;

    var chartEl = card.querySelector("[data-flow-chart]");
    var statusEl = card.querySelector("[data-chart-status]");

    if (!chartEl || chartEl.getAttribute("data-rendered") === "true") return;

    if (!row.flowPoints || row.flowPoints.length < 2) {
      if (statusEl) statusEl.innerHTML = "Not enough hourly data to draw chart.";
      return;
    }

    if (state.historicalCache[row.gauge.site] !== undefined) {
      renderChartIntoCard(row, card, state.historicalCache[row.gauge.site]);
      return;
    }

    if (statusEl) statusEl.innerHTML = "Loading historical average for today...";

    fetchHistoricalToday(row.gauge.site)
      .then(function (historicalFlow) {
        state.historicalCache[row.gauge.site] = historicalFlow;
        renderChartIntoCard(row, card, historicalFlow);
      })
      .catch(function () {
        state.historicalCache[row.gauge.site] = null;
        renderChartIntoCard(row, card, null);
      });
  }

  function fetchHistoricalToday(site) {
    var params =
      "format=rdb" +
      "&sites=" + encodeURIComponent(site) +
      "&parameterCd=00060" +
      "&statReportType=daily" +
      "&statType=mean";

    var url = "https://waterservices.usgs.gov/nwis/stat/?" + params;

    return fetch(url, { cache: "no-store" })
      .then(function (response) {
        if (!response.ok) throw new Error("USGS historical API error");
        return response.text();
      })
      .then(function (text) {
        return parseHistoricalToday(text);
      });
  }

  function parseHistoricalToday(rdbText) {
    var today = new Date();
    var month = String(today.getMonth() + 1).padStart(2, "0");
    var day = String(today.getDate()).padStart(2, "0");

    var lines = String(rdbText || "").split("\n").filter(function (line) {
      return line && line.charAt(0) !== "#";
    });

    if (lines.length < 3) return null;

    var headers = lines[0].split("\t");
    var dataLines = lines.slice(2);

    var monthIndex = headers.indexOf("month_nu");
    var dayIndex = headers.indexOf("day_nu");
    var meanIndex = headers.indexOf("mean_va");

    if (meanIndex === -1) meanIndex = headers.indexOf("p50_va");
    if (monthIndex === -1 || dayIndex === -1 || meanIndex === -1) return null;

    for (var i = 0; i < dataLines.length; i++) {
      var cols = dataLines[i].split("\t");
      var rowMonth = String(cols[monthIndex]).padStart(2, "0");
      var rowDay = String(cols[dayIndex]).padStart(2, "0");
      var value = Number(cols[meanIndex]);

      if (rowMonth === month && rowDay === day && !isNaN(value)) {
        return value;
      }
    }

    return null;
  }

  function renderChartIntoCard(row, card, historicalFlow) {
    var chartEl = card.querySelector("[data-flow-chart]");
    var statusEl = card.querySelector("[data-chart-status]");

    if (!chartEl) return;

    chartEl.innerHTML = makeSevenDayFlowChart(row.flowPoints, historicalFlow);
    chartEl.setAttribute("data-rendered", "true");

    if (statusEl) {
      statusEl.innerHTML = historicalFlow
        ? "Blue line: hourly flow over past 7 days. Dashed line: historical average for today."
        : "Blue line: hourly flow over past 7 days. Historical average unavailable for this site.";
    }
  }

  function makeSevenDayFlowChart(points, historicalFlow) {
    var clean = (points || []).filter(function (p) {
      return p && !isNaN(p.value) && p.time;
    });

    if (clean.length < 2) return "";

    var width = 620;
    var height = 240;
    var padLeft = 54;
    var padRight = 18;
    var padTop = 18;
    var padBottom = 42;
    var chartW = width - padLeft - padRight;
    var chartH = height - padTop - padBottom;

    var values = clean.map(function (p) { return p.value; });
    if (historicalFlow !== null && historicalFlow !== undefined && !isNaN(historicalFlow)) {
      values.push(Number(historicalFlow));
    }

    var min = Math.min.apply(null, values);
    var max = Math.max.apply(null, values);
    var padding = Math.max(5, (max - min) * 0.12);
    min = Math.max(0, min - padding);
    max = max + padding;
    var range = max - min || 1;

    function xScale(i) {
      return padLeft + (i / Math.max(clean.length - 1, 1)) * chartW;
    }

    function yScale(v) {
      return padTop + chartH - ((v - min) / range) * chartH;
    }

    var currentPoints = clean.map(function (p, i) {
      return xScale(i) + "," + yScale(p.value);
    }).join(" ");

    var yTicks = [];
    for (var y = 0; y <= 4; y++) {
      var val = min + (range * y / 4);
      yTicks.push(Math.round(val));
    }

    var xTickIndexes = uniqueIndexes([
      0,
      Math.round((clean.length - 1) * 0.25),
      Math.round((clean.length - 1) * 0.50),
      Math.round((clean.length - 1) * 0.75),
      clean.length - 1
    ]);

    var svg = "";
    svg += "<svg viewBox='0 0 " + width + " " + height + "' preserveAspectRatio='none'>";

    yTicks.forEach(function (tick) {
      var yPos = yScale(tick);
      svg += "<line class='bqa-rf-grid' x1='" + padLeft + "' y1='" + yPos + "' x2='" + (width - padRight) + "' y2='" + yPos + "'></line>";
      svg += "<text class='bqa-rf-tick-label' x='" + (padLeft - 8) + "' y='" + (yPos + 4) + "' text-anchor='end'>" + tick.toLocaleString() + "</text>";
    });

    xTickIndexes.forEach(function (idx) {
      var xPos = xScale(idx);
      var label = shortDateLabel(clean[idx].time);
      svg += "<line class='bqa-rf-grid' x1='" + xPos + "' y1='" + padTop + "' x2='" + xPos + "' y2='" + (height - padBottom) + "'></line>";
      svg += "<text class='bqa-rf-tick-label' x='" + xPos + "' y='" + (height - 22) + "' text-anchor='middle'>" + escapeHtml(label) + "</text>";
    });

    svg += "<line class='bqa-rf-axis' x1='" + padLeft + "' y1='" + padTop + "' x2='" + padLeft + "' y2='" + (height - padBottom) + "'></line>";
    svg += "<line class='bqa-rf-axis' x1='" + padLeft + "' y1='" + (height - padBottom) + "' x2='" + (width - padRight) + "' y2='" + (height - padBottom) + "'></line>";

    if (historicalFlow !== null && historicalFlow !== undefined && !isNaN(historicalFlow)) {
      var histY = yScale(Number(historicalFlow));
      svg += "<line class='bqa-rf-historical-line' x1='" + padLeft + "' y1='" + histY + "' x2='" + (width - padRight) + "' y2='" + histY + "'></line>";
      svg += "<text class='bqa-rf-legend bqa-rf-legend-historical' x='" + (width - padRight - 4) + "' y='" + (histY - 6) + "' text-anchor='end'>Hist avg " + Math.round(historicalFlow).toLocaleString() + " cfs</text>";
    }

    svg += "<polyline class='bqa-rf-current-line' points='" + currentPoints + "'></polyline>";

    svg += "<text class='bqa-rf-axis-label' x='" + (padLeft + chartW / 2) + "' y='" + (height - 4) + "' text-anchor='middle'>Past 7 days</text>";
    svg += "<text class='bqa-rf-axis-label' transform='translate(12 " + (padTop + chartH / 2) + ") rotate(-90)' text-anchor='middle'>Flow (cfs)</text>";
    svg += "<text class='bqa-rf-legend bqa-rf-legend-current' x='" + padLeft + "' y='12'>Hourly flow</text>";
    svg += "</svg>";

    return svg;
  }

  function uniqueIndexes(indexes) {
    var seen = {};
    return indexes.filter(function (idx) {
      if (idx < 0 || seen[idx]) return false;
      seen[idx] = true;
      return true;
    });
  }

  function shortDateLabel(iso) {
    try {
      return new Date(iso).toLocaleDateString([], { month: "short", day: "numeric" });
    } catch (e) {
      return String(iso || "").slice(5, 10);
    }
  }


  function formatReadingTime(iso) {
    if (!iso) return "Unavailable";

    try {
      return new Date(iso).toLocaleString([], {
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit"
      });
    } catch (e) {
      return iso;
    }
  }

  function findRow(site) {
    for (var i = 0; i < state.rows.length; i++) {
      if (state.rows[i].gauge.site === site) return state.rows[i];
    }
    return null;
  }

  function recommendation(row) {
    var flow = row.flow;
    var temp = Number(row.temp);

    if (temp >= 68) return { label: "Temp Caution", className: "danger" };
    if (temp >= 66) return { label: "Watch Temps", className: "watch" };
    if (flow === null) return { label: "Check Report", className: "watch" };
    if (flow >= row.gauge.idealLow && flow <= row.gauge.idealHigh) return { label: "Good", className: "good" };
    if (flow < row.gauge.idealLow) return { label: "Low Flow", className: "watch" };
    return { label: "High Water", className: "watch" };
  }

  function conditionScore(row) {
    var rec = recommendation(row);
    if (rec.className === "good") return 100;
    if (rec.label === "Check Report") return 20;
    if (rec.label === "Temp Caution") return 5;
    return 50;
  }

  function tempClass(temp) {
    var n = Number(temp);
    if (isNaN(n)) return "";
    if (n >= 68) return " danger";
    if (n >= 66) return " warn";
    return "";
  }

  function trendInfo(row) {
    var points = row.flowPoints || [];
    if (points.length < 2 || row.flow === null) {
      return { label: "steady", className: "", text: "Not enough recent readings" };
    }

    var first = points[0].value;
    var last = points[points.length - 1].value;
    var diff = last - first;
    var pct = first ? Math.abs(diff / first) : 0;

    if (pct < 0.05) return { label: "steady", className: "", text: "Mostly steady over the recent period" };
    if (diff > 0) return { label: "up", className: "rising", text: "Rising over the recent period" };
    return { label: "down", className: "falling", text: "Falling over the recent period" };
  }

  function toggleFavorite(site) {
    if (isFavorite(site)) {
      state.favorites = state.favorites.filter(function (saved) {
        return saved !== site;
      });
    } else {
      state.favorites.push(site);
    }

    saveFavorites();
    render();
  }

  function isFavorite(site) {
    return state.favorites.indexOf(site) !== -1;
  }

  function loadFavorites() {
    try {
      return JSON.parse(localStorage.getItem("bqaRiverFlowFavorites") || "[]");
    } catch (e) {
      return [];
    }
  }

  function saveFavorites() {
    try {
      localStorage.setItem("bqaRiverFlowFavorites", JSON.stringify(state.favorites));
    } catch (e) {}
  }

  function updateHeaderTime() {
    var updatedEl = document.getElementById("bqa-rf-updated");
    if (!updatedEl || !state.loadedAt) return;
    updatedEl.innerHTML =
      "Updated " +
      state.loadedAt.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
  }

  function updateRelativeTime() {
    var statusEl = document.getElementById("bqa-rf-status");
    if (!statusEl || !state.rows.length) return;
    statusEl.innerHTML =
      "Live USGS and Colorado DWR river conditions • " +
      filteredRows().length +
      " of " +
      state.rows.length +
      " rivers • " +
      relativeLoadedText();
  }

  function relativeLoadedText() {
    if (!state.loadedAt) return "updating now";
    var diffMs = new Date().getTime() - state.loadedAt.getTime();
    var mins = Math.max(0, Math.round(diffMs / 60000));
    if (mins < 1) return "updated just now";
    if (mins === 1) return "updated 1 min ago";
    return "updated " + mins + " min ago";
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  startRiverFlowApp();
  document.addEventListener("DOMContentLoaded", startRiverFlowApp);
  window.addEventListener("load", startRiverFlowApp);
})();
